<template lang="pug">
  .component-selectize-driver
    loading-spinner(v-if = "loading")
    selectize(v-if="options", :selectedValue="selectedValue" :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",  :allowEmptyOption="allowEmptyOption", placeholder="Categories")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import LoadingSpinner from "../../../LoadingSpinner";

  export default {
    name: 'SelectizeCategory',
    extends: BaseSelectize,
    components: {LoadingSpinner, Selectize},
    data() {
      return {
        loading: true,
        searchableFields: ['id', 'name']
      }
    },
    created() {
      KeplerBackofficeSdk.selects.vehicleCategories((data) => {
        this.options = data
        this.loading = false
      })
    },
    methods: {
      optionTemplate(item, escape) {
        if (item.id) {
          return `<div><div><small>C${item.id}</small></div><div>${item.name}</div></div>`
        }
        return `<div><div>Select category</div></div>`
      },
      renderTemplate(item, escape) {
        if (item.id) {
          return `<div>${item.name}</div>`
        }
        return `<div>Select category</div>`
      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeCategory.vue?bf220bfa